import { cn } from "@simble/shared/lib/cn";

const LoadingIndicator = ({ className, ...props }: React.ComponentProps<"figure">) => (
  <figure
    className={cn(
      "absolute inset-0 z-50 flex items-center justify-center before:size-10 before:animate-spin before:rounded-full before:border-4 before:border-sber before:border-t-transparent before:content-['']",
      className
    )}
    {...props}
  />
);

export default LoadingIndicator;
